import { useState } from "react"

import VideoPreview from "@fuse/sharedComponents/openDoorExperiments/videoPreview/VideoPreview"
import { EFeatureFlags } from "@letshang/constants"

import { useProcessFeatureFlags } from "@settingsAlias/featureFlags"

export const VideoPreviewExperiment = () => {
  const [isEnabled, setIsEnabled] = useState(true)

  const isVideoPreviewEnabled = useProcessFeatureFlags(
    EFeatureFlags.VIDEO_PREVIEW,
  )
  if (!isVideoPreviewEnabled) return null

  if (!isEnabled) return null

  const onClose = () => {
    setIsEnabled(false)
  }
  return (
    <div className="space-y-2 bg-white/10 w-full rounded-2xl">
      <VideoPreview onClose={onClose} />
    </div>
  )
}
